import React from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import BackToTop from '../../components/BackToTop/BackToTop';
import FlipCard from '../../components/FlipCard/FlipCard';
import './Trade.css';

const Trade = () => {
  useScrollAnimation();

  const tradeDivisions = [
    {
      frontImage: "/logos/Trimline Polymers.png",
      frontTitle: "Polymers",
      frontDescription: "A leading player in the global plastic trading industry.",
      backTitle: "Polymers Division",
      backDescription: "Unleashing Innovation In Polymers, offering the best value resins, including PET, PP, HDPE, LDPE, LLDPE, PVC, and more, for a world of possibilities.",
      link: "https://trimlinepolymers.com/",
      linkText: "Explore Division",
      stats: ["Global Reach", "Premium Quality", "20+ Years Experience"]
    },
    {
      frontImage: "/logos/Trimline Commodities.png",
      frontTitle: "AgriCommodities",
      frontDescription: "One of the largest Tea & Coffee beans importers in Pakistan",
      backTitle: "AgriCommodities Division",
      backDescription: "Intelligent writing assistant that creates high-quality content for marketing, communications, and business documentation.",
      link: "#",
      linkText: "Explore Division",
      stats: ["Premium Quality", "Sustainable Sourcing", "Global Network"]
    },
    {
      frontImage: "/logos/Trimline Chemicals.png",
      frontTitle: "Jade Chemi",
      frontDescription: "Distributors, manufacturers & suppliers of chemicals",
      backTitle: "Jade Chemi Division",
      backDescription: "At Trimline Zhejiang Jade Chemicals, we are global chemical suppliers offering reliable, high-quality chemicals across various industries.",
      link: "https://jadechemi.com/",
      linkText: "Explore Division",
      stats: ["Chemical Experts", "Quality Assurance", "Industry Leaders"]
    }
  ];

  const globalOperations = [
    { location: "USA", company: "Trimline International LLC", flag: "🇺🇸" },
    { location: "UAE", company: "Trimline International LLC", flag: "🇦🇪" },
    { location: "China", company: "Jiangyin Jietong Zhejiang Chemicals", flag: "🇨🇳" },
    { location: "Singapore", company: "Intersmart Singapore", flag: "🇸🇬" }
  ];

  return (
    <div className="trade-page">
      {/* Hero Section */}
      <section className="trade-hero">
        <div className="hero-background">
                    <video className="hero-video" autoPlay muted loop playsInline>
            <source src="/video/trade-video.mp4" type="video/mp4" />
          </video>
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">International Trade</h1>
            <p className="hero-subtitle">
              Connecting Global Markets Through Strategic Partnerships and Premium Supply Chain Solutions
            </p>
            <div className="hero-stats">
              <div className="stat">
                <span className="stat-number">48</span>
                <span className="stat-label">Years of Excellence</span>
              </div>
              <div className="stat">
                <span className="stat-number">100+</span>
                <span className="stat-label">Global Partners</span>
              </div>
              <div className="stat">
                <span className="stat-number">4</span>
                <span className="stat-label">Core Divisions</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="intro-section">
        <div className="container">
          <div className="intro-content">
            <div className="intro-text">
              <h2>Global Trade Excellence</h2>
              <p>
                The International Trade business is conducted through various subsidiaries and associate companies including{' '}
                <strong>Trimline International LLC USA, Trimline International LLC UAE, Trimline Polymers, 
                Trimline Commodities, Zhejiang Chemicals, Jiangyin Jietong Zhejiang Chemicals China and Intersmart Singapore</strong>.
              </p>
              <p>
                Our international trade operations are strategically divided into four core business divisions including{' '}
                <strong>Polymers, Chemicals, Agri Commodities and Metals</strong>, each specializing in delivering 
                exceptional value and quality to our global clientele.
              </p>
            </div>
            <div className="global-operations">
              <h3>Global Operations</h3>
              <div className="operations-grid">
                {globalOperations.map((operation, index) => (
                  <div className="operation-card" key={index}>
                    <span className="flag">{operation.flag}</span>
                    <h4>{operation.location}</h4>
                    <p>{operation.company}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trade Divisions Section */}
      <section className="divisions-section">
        <div className="container">
          <div className="section-header">
            <h2>Our Trade Divisions</h2>
            <p>Specialized business units driving global trade excellence</p>
          </div>
          
          <div className="flip-cards-grid">
            {tradeDivisions.map((division, index) => (
              <FlipCard
                key={index}
                frontImage={division.frontImage}
                frontTitle={division.frontTitle}
                frontDescription={division.frontDescription}
                backTitle={division.backTitle}
                backDescription={division.backDescription}
                link={division.link}
                linkText={division.linkText}
                stats={division.stats}
              />
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="trade-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Partner with Us?</h2>
            <p>Join our network of global partners and experience the Trimline Group advantage in international trade.</p>
            <div className="cta-buttons">
              <a href="/contact" className="btn btn-primary">Get in Touch</a>
              <a href="/about" className="btn btn-secondary">Learn More</a>
            </div>
          </div>
        </div>
      </section>

      <BackToTop />
    </div>
  );
};

export default Trade;